<template>
  <div class="campaign-preview-block">
    <h3 class="campaign-preview-block__title">
      {{ campaign.title }}
    </h3>
    <div class="campaign-preview-block__description" v-html="campaign.description"></div>
    <oie-action-link
      is-type="a"
      :url="campaign.url"
      :text="tStatic('goToCampaign')"
      class="campaign-preview-block__link">
      <template #after>
        <oie-use-svg svg="caret" height="12" width="12"></oie-use-svg>
      </template>
    </oie-action-link>

    <oie-layout-grid class="grid--five campaign-preview-block__products">
      <oie-product-shell v-for="product in campaign.products" :key="product.id">
        <oie-product-card :product="product" :show-unhighlighted-description="true"></oie-product-card>

        <oie-product-technical-information v-if="mq('to-small') && Object.keys(product.specification).length > 0" slot="technical-information" :product-id="product.id">
          <div class="grid grid--four techinical-facts__grid">
            <div v-for="(technicalSpec, categoryName) in product.specification" :key="categoryName" class="property-container">
              <div class="property-container__header">
                {{ categoryName }}
              </div>

              <table class="property-table technical-facts__table">
                <tr v-for="(value, key) in technicalSpec" :key="key" class="property-table__item">
                  <td>
                    {{ key }}
                  </td>

                  <td>
                    {{ value }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </oie-product-technical-information>
      </oie-product-shell>
    </oie-layout-grid>
  </div>
</template>

<script>
export default {
  props: {
    campaign: {
      type: Object,
      required: true
    }
  }

}
</script>

<style lang="scss">
.campaign-preview-block {
  background-color: color(white);
  border: 1px solid color(campaign-red);
  padding: measure(half);
}

.campaign-preview-block__title {
  @include h2-bold;
  margin-top: 0;
  color: color(campaign-red);
}

.grid--five.campaign-preview-block__products {
  margin-bottom: measure(half);
}

.campaign-preview-block__link {
  color: color(text-blue);
  margin-bottom: measure(half);

  > svg {
    margin-left: measure(eighth);
  }
}
</style>
